import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import {
  SENTRY_REPLAY_SAMPLE_RATE,
  SENTRY_TRACE_PROPAGATION_TARGETS,
  SENTRY_TRACES_SAMPLE_RATE,
} from './constants/sentry'

const dsn =
  window.__RUNTIME_CONFIG__?.SENTRY_DSN?.trim() ||
  import.meta.env.VITE_SENTRY_DSN?.trim()

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: import.meta.env.PROD
      ? SENTRY_TRACES_SAMPLE_RATE.production
      : SENTRY_TRACES_SAMPLE_RATE.development,
    tracePropagationTargets: SENTRY_TRACE_PROPAGATION_TARGETS,
    replaysSessionSampleRate: SENTRY_REPLAY_SAMPLE_RATE.session,
    replaysOnErrorSampleRate: SENTRY_REPLAY_SAMPLE_RATE.onError,
  })
}
